export default __webpack_public_path__ + "static/media/IRCTC_LOGO.b72b2d4b.png";